module.exports = __webpack_public_path__ + "static/04-286cc3119ea0dbb7283e827fc9932048.jpg";